import axios from "../api/axiosInstance";

export const getInvoiceList = (params) => {
    return axios.get("/Invoice/InvoiceList", { params });
  };

  export const getInvoiceItems = (invoiceRef) => {
    return axios.get("/Invoice/InvoiceItems", {
      params: { invoiceRef },
    });
  };

  export const getReturnInvoiceList = (params) => {
    return axios.get("/Invoice/ReturnInvoiceList", {
       params ,
    });
  };

  
  export const getReturnInvoiceItems = (returnInvoiceId) => {
    return axios.get("/Invoice/ReturnInvoiceItems", {
      params: { returnInvoiceId },
    });
  };